export default __webpack_public_path__ + "static/media/hht1_ep14_timeline_q03_a.be98a493.png";